import * as types from "../../ActionType";

const initState = {
    expenses: [],
    accountDetails: {},
    loadingExpenses: true,
    one_expense: {},
    loadingOneExpense: true,
    page_list_expenses: {},
    loadingPageListExpenses: true,
}

const ExpensesReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_EXPENSE:
            return { ...state, loadingExpenses: true }
        case types.GET_EXPENSES:
            return { ...state, expenses: action.payload, loadingExpenses: false }
        case types.GET_EXPENSES1:
            return { ...state, accountDetails: action.payload }
        case types.PAGE_LIST_EXPENSE:
            return { ...state, page_list_expenses: action.payload, loadingPageListExpenses: false }
        case types.GET_ONE_EXPENSE:
            return { ...state, one_expense: action.payload, loadingOneExpense: false }
        case types.EMPTY_ONE_EXPENSE:
            return { ...state, one_expense: action.payload, loadingOneExpense: true }
        case types.DELETE_EXPENSE:
            return { ...state }
        case types.EDIT_EXPENSE:
            return { ...state, loadingExpenses: true }
        default:
            return state;
    }
};

export default ExpensesReducer;


